import './css/Footer.css';

const Footer = () => {
  const urls = {
    github: 'https://github.com/jamescer/',
    linkedin: 'https://www.linkedin.com/in/jamescerniglia/',
    twitter: 'https://twitter.com/BIG_SQUEEZER',
    angel: 'https://angel.co/u/james-cerniglia',
    twitch: 'https://twitch.tv/BIG_SQUEEZER',
    insta: 'https://www.instagram.com/james.cer/',
    facebook: 'https://www.facebook.com/james.cerniglia/',
  };

  return (
    <footer className="ftr">
      <div className="container d-flex flex-column flex-md-row justify-content-between align-items-center">
        <div id="icons" className="d-flex mb-3 mb-md-0">
          <a className="icon" href={urls.github} aria-label="GitHub" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-github fa-lg"></i>
          </a>
          <a className="icon" href={urls.linkedin} aria-label="LinkedIn" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-linkedin fa-lg"></i>
          </a>
          <a className="icon" href={urls.twitter} aria-label="Twitter" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-twitter-square fa-lg"></i>
          </a>
          <a className="icon" href={urls.twitch} aria-label="Twitch" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-twitch fa-lg"></i>
          </a>
          <a className="icon" href={urls.insta} aria-label="Instagram" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-instagram fa-lg"></i>
          </a>
          <a className="icon" href={urls.facebook} aria-label="Facebook" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-facebook-square fa-lg"></i>
          </a>
          <a className="icon" href={urls.angel} aria-label="AngelList" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-angellist fa-lg"></i>
          </a>
        </div>
        <div className="text-center text-md-right">
          <p className="mb-0">
            <i className="far fa-copyright"></i> 2025 James Cerniglia
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
